<template>
    <span>
      <v-dialog v-model="show" persistent :fullscreen="fullscreen" :max-width="max_width" overlay transition="dialog-bottom-transition" scrollable>
        <v-card class="text-center">
          <v-card-title class="primary font-weight-bold text-sm-body-6 white--text"  style="text-align: center">
            Login
            <v-spacer></v-spacer>
            <v-btn icon dark @click="Close()" >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="text-center">
            <v-container fluid>
              <v-form>
                <v-text-field
                  class="pt-4"
                  dense
                  outlined
                  label="Account"
                  prepend-inner-icon="mdi-account"
                  v-model="userid"
                  :readonly="loading"
                  :disabled="loading"
                />
                <v-text-field
                  dense
                  outlined
                  label="Password"
                  placeholder="Password"
                  prepend-inner-icon="mdi-lock"
                  :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showpass ? 'text' : 'password'"
                  @click:append="showpass = !showpass"
                  v-model="user_pass"
                  :rules="rules.valor"
                  :readonly="loading"
                  :disabled="loading"
                />
              </v-form>
            </v-container>
            <v-btn
              class="ml-2"
              color="success"
              @click="Login()"
              :disabled="loading"
              >
              Login
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      
    </span>
</template>
<script>
import axios from 'axios'; 
import Vue from 'vue'
export default {
    props:[
      'id',
      'show',
      'isNew',
    ],
    data: () => ({
      registroActual: {},
      nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      contacto_id: null,
      modo_registro: false,
      fullscreen: false,
      max_width: 480,
      save_seccion: true,
      showpass: false,
      email: '',
      userid: '',
      user_pass: '',
      valid: true,
      renameRules: [
        v => !!v || "This field is required",
        v => /^[a-zA-Z0-9\s]+$/.test(v) || "Only English alphabet characters, numbers and spaces are allowed.",
        v => (v && (v.length >= 4 && v.length <= 64)) || "Must contain at least 4 characters"
        ],
      isVertical: true,
      rules: {},
      loading: false,
    }),
    mounted() {
    },
    methods: {
      Login(){
        this.registroActual.userid = this.userid;
        this.registroActual.user_pass = this.user_pass;
        this.loading = true; // Inicia el loading
        axios
          .post('user/login',this.registroActual)
          .then(response => {
            let data_user = response.data;
            this.registroActual = {};
            this.$emit('login',data_user);
            return;
          })
          .catch(this.MSGBOX)
          .finally(() => {
            this.loading = false; // Esto se ejecuta siempre
          });
      },
      Close(){
        this.$emit('close');
      },

    },
    watch: {
    }
}
</script>